/* eslint no-underscore-dangle:0 */
import React from "react";
import ReactDOM from "react-dom";
import { PasswordStrength } from "@treatwell/ui";
import events from "../../../../common/event-aggregator";
import { attachShowHidePasswordHandler } from "../../show-hide-password";

define(function (require) {
  const { validatePassword } = require("./validate-password");
  var $ = require("jquery");
  var CommonView = require("site/common/view");
  var PageConfig = require("common/page-config");
  var Popup = require("site/common/popup");
  var responsive = require("site/common/responsive");
  const track = require("site/common/analytics/sign-up-events");
  var _ = require("underscore");

  require("common/form-validation-rules/postal-ref");
  require("common/form-validation-rules/regexp");

  const isNewRegisterAPIsEnabled = _.contains(
    PageConfig.uiChannelFeatures,
    "USE_NEW_ACCOUNT_API"
  );

  return CommonView.extend({
    ui: {
      form: $(".form-register"),
      error: $("<div/>")
        .addClass("error-message")
        .append($("<span/>").text(PageConfig.failureMessage)),
      postalRef: $("#postal-ref"),
      password: $("#password"),
      tandc: $(".a-show-terms-and-conditions"),
      privacyPolicy: $(".a-show-privacy-policy")
    },

    events: {
      "click .a-show-terms-and-conditions": "openPopup",
      "click .a-show-privacy-policy": "openPopup",
      "focus #email-address": track.email,
      "focus #password": track.password,
      "focus #first-name": track.firstName,
      "focus #last-name": track.lastName,
      "focus #postal-ref": track.postalRef,
      "change #newsletter": (event) => track.newsletter($(event.currentTarget)),
      "change #genderMale": (event) => track.genderMale($(event.currentTarget)),
      "change #genderFemale": (event) =>
        track.genderFemale($(event.currentTarget)),
      "click button.submit": track.submit
    },

    locale: null,

    initialize () {
      this.locale = (PageConfig.locale && PageConfig.locale.locale) || "gb";
      // set fields attributes
      this.addFieldsAttributes();
      // render terms and conditions / privacy policy popup
      this.renderPopup();

      this.initialisePasswordStrength();

      attachShowHidePasswordHandler({
        viewId: "#view-password-button",
        hideId: "#hide-password-button"
      });
    },

    addFieldsAttributes () {
      if (this.locale === "en_GB") {
        // set postcode attributes
        this.ui.postalRef.alphanumeric({
          allow: "-. "
        });
      }
    },

    renderPopup () {
      var dimensions = { width: 800, height: 600 };

      this.ui.tandcPopup = new Popup("#tandc", dimensions);
      this.ui.privacyPolicyPopup = new Popup("#privacy-policy", dimensions);
    },

    openPopup (evt) {
      if (responsive.isSmallScreen()) {
        return;
      }

      evt.preventDefault();

      if (evt.target === this.ui.tandc.get(0)) {
        this.ui.tandcPopup.open();
      }

      if (evt.target === this.ui.privacyPolicy.get(0)) {
        this.ui.privacyPolicyPopup.open();
      }
    },

    initialisePasswordStrength () {
      if (!isNewRegisterAPIsEnabled) {
        return;
      }

      $(
        ".site-question.hide-for-small-only, .note.show-for-small-only"
      ).remove();
      this.ui.password.after('<div id="pw-strength" class="pw-strength" />');
      events.on(
        events.PASSWORD_VALUE_CHANGED,
        ({ passwordRules, passwordValue }) => {
          this.renderPasswordStrength(passwordRules, passwordValue);
        }
      );
    },

    renderPasswordStrength (passwordRules, passwordValue = "") {
      ReactDOM.render(
        <PasswordStrength
          rules={passwordRules}
          passwordValue={passwordValue}
        />,
        document.querySelector("#pw-strength")
      );
    },

    validation (passwordRules) {
      const shouldUseNewValidation = isNewRegisterAPIsEnabled && passwordRules;
      if (shouldUseNewValidation) {
        const validatePasswordMethod = validatePassword(passwordRules);
        $.validator.addMethod("validatePassword", validatePasswordMethod, "");
        this.renderPasswordStrength(passwordRules);
      }

      var validations = {
        rules: {
          emailAddress: {
            required: true,
            email: true
          },
          password: {
            required: true,
            minlength: 8
          },
          firstName: {
            required: true,
            minlength: 1
          },
          lastName: {
            required: true,
            minlength: 1
          },
          postalRef: {
            required: false,
            postalRef: {}
          }
        },
        messages: {
          ...PageConfig.cms.validationMessages,
          emailAddress: PageConfig.cms.validationMessages["email-address"],
          postalRef: PageConfig.cms.validationMessages["postal-ref"]
        }
      };

      if (shouldUseNewValidation) {
        validations.rules.password = { validatePassword: true };
        validations.onkeyup = function (element, event) {
          if (event.which === 9 && this.elementValue(element) === "") {
            return;
          } else if (
            element.name in this.submitted ||
            element === this.lastElement ||
            element.name === "password"
          ) {
            this.element(element);
          }
        };
      }

      return validations;
    },

    getValues () {
      return this._getFormValues();
    }
  });
});
